import React, { useMemo } from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import slugify from "@sindresorhus/slugify";

const OnlineStore = ({ data }) => {
  const { anchorDesktop, description, boxImageFieldSet } = data;
  const boxes = useMemo(
    () => boxImageFieldSet.filter((item) => item.boxImage).map((item) => item),
    [boxImageFieldSet]
  );
  return (
    <>
      {anchorDesktop && <span id={slugify(anchorDesktop)} className="tabs__scroll-anchor" />}
      <section className="section online-store">
        <div className="container-fluid">
          {description && (
            <div className="row">
              <div className="col-12 text-center pt-4 px-3 mb-4">
                <div dangerouslySetInnerHTML={{ __html: description }}></div>
              </div>
            </div>
          )}
          <div className="row">
            {boxes.map((item, i) => (
              <div className="col-md-3 col-6 d-flex align-items-center" key={i}>
                <a
                  href={item.link}
                  className="online-store__box d-flex align-items-center align-self-stretch w-100 mt-3 pl-3 pb-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item?.altImage}
                >
                  <GatsbyImage image={getImage(item?.boxImage.node)} alt={item?.altImage} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OnlineStore;
export const fragment = graphql`
  fragment OnlineStoreFragment on LiferayOnlineStore {
    id
    liferayFields {
      siteId
      articleId
    }
    anchorDesktop
    anchorMobile
    position
    description
    boxImageFieldSet {
      boxImage {
        node {
          gatsbyImageData(width: 500, layout: CONSTRAINED)
        }
      }
      altImage
      link
    }
  }
`;
